import { gql } from "@apollo/client";

export const PAGE_SIZE = 20;

const SYSTEM_TASK_ITEM_FIELDS = gql`
  fragment SystemTaskItemFields on SystemTaskItemType {
    id
    objectType
    objectId
    title
    status
    data
    detectedAt
    resolvedAt
  }
`;

export const FETCH_MY_SYSTEM_TASKS = gql`
  ${SYSTEM_TASK_ITEM_FIELDS}
  query MySystemTasks($includeCompleted: Boolean, $options: CommonOptionsInput) {
    mySystemTasks(includeCompleted: $includeCompleted, options: $options) {
      total
      results {
        id
        taskType
        scopeKey
        source
        title
        data
        createdAt
        updatedAt
        completedAt
        assignee {
          id
          email
          username
        }
        openItems {
          ...SystemTaskItemFields
        }
        items {
          ...SystemTaskItemFields
        }
      }
    }
  }
`;

export const FETCH_SYSTEM_TASK = gql`
  ${SYSTEM_TASK_ITEM_FIELDS}
  query SystemTask($id: ID!) {
    systemTask(id: $id) {
      id
      taskType
      title
      source
      completedAt
      openItems {
        ...SystemTaskItemFields
      }
      items {
        ...SystemTaskItemFields
      }
    }
  }
`;

export const RESOLVE_SYSTEM_TASK_ITEM = gql`
  mutation ResolveSystemTaskItem($id: ID!) {
    resolveSystemTaskItem(id: $id) {
      item {
        id
        status
        resolvedAt
        task {
          id
          completedAt
        }
      }
    }
  }
`;
